import { createAction } from 'redux-actions';

export const SET_SELECTED_PASSENGER_ID = 'SET_SELECTED_PASSENGER_ID';

export const setSelectedPassengerId = createAction<number>(SET_SELECTED_PASSENGER_ID);

export type SetSelectedPassengerId = ReturnType<typeof setSelectedPassengerId>;
